/**
 * Constants file for Track Analytics Events.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class TrackingConstants {
    // User Preferences events Tracking.
    public static USER_PREFERENCES = 'UserPreferences';
    public static SAVE_USER_PREFERENCES = 'SaveUserPreferences';
    public static RESET_USER_PREFERENCES = 'ResetUserPreferences';

    // Change Password events Tracking.
    public static CHANGE_PASSWORD = 'ChangePassword';
    public static SAVE_CHANGE_PASSWORD = 'SaveChangePassword';

    // Create Person events Tracking.
    public static CREATE_PERSON = 'CreatePerson';
    public static SAVE_PERSON = 'SavePerson';

    // Create Organisation events Tracking.
    public static CREATE_ORGANISATION = 'CreateOrganisation';
    public static SAVE_ORGANISATION = 'SaveOrganisation';

    // Generic Search events Tracking.
    public static GENERIC_SEARCH = 'GenericSearch';
    public static OPEN_NEW_ORG_LINK = 'NewOrganisationLink';
    public static OPEN_NEW_PERSON_LINK = 'NewPersonLink';

    // Payment events Tracking.
    public static PAYMENTS = 'Payments';
    public static SAVE_PAYMENT = 'SavePayment';
    public static DELETE_PAYMENT = 'DeletePayment';

    // Bank Institution events Tracking.
    public static BANK_INSTITUTIONS = 'BankInstitutions';
    public static SAVE_BANK_INSTITUTION = 'SaveBankInstitution';
    public static DELETE_BANK_INSTITUTION = 'DeleteBankInstitution';

    // Bank Account events Tracking.
    public static BANK_ACCOUNTS = 'BankAccounts';
    public static SAVE_BANK_ACCOUNT = 'SaveBankAccount';
    public static DELETE_BANK_ACCOUNT = 'DeleteBankAccount';

    // Integration events Tracking.
    public static INTEGRATIONS = 'Integrations';
    public static SAVE_INTEGRATION = 'SaveIntegration';
    public static DELETE_INTEGRATION = 'DeleteIntegration';

    // Survey Managements events Tracking.
    public static SURVEY_MANAGEMENT = 'SurveyManagement';
    public static SAVE_SURVEY_CONFIG = 'SaveSurveyConfig';
    public static DELETE_SURVEY_CONFIG = 'DeleteSurveyConfig';
    public static SAVE_SURVEY_TEMPLATE = 'SaveSurveyTemplate';
    public static DELETE_SURVEY_TEMPLATE = 'DeleteSurveyTemplate';
    public static SAVE_SURVEY_QUESTION = 'SaveSurveyQuestion';
    public static DELETE_SURVEY_QUESTION = 'DeleteSurveyQuestion';
    public static CLEAR_SURVEY_QUESTION_RESPONSE = 'ClearSurveyQuestionResponse';
    public static MOVE_SURVEY_QUESTION_RESPONSE = 'MoveSurveyQuestionResponse';

    // Rule Managements events Tracking.
    public static RULE_MANAGEMENT = 'RuleManagement';
    public static SAVE_RULE_GROUP = 'SaveRuleGroup';
    public static SAVE_RULE_GROUP_FUNCTIONALITY = 'SaveRuleGroupFunctionality';
    public static SAVE_RULE = 'SaveRule';
    public static VALIDATE_RULE = 'ValidateRule';
    public static DELETE_RULE_GROUP_FUNCTIONALOITY = 'DeleteRuleGroupFunctionality';
    public static DELETE_RULE = 'DeleteRule';
    public static DELETE_RULE_GROUP = 'DeleteRuleGroup';
    public static RULE_PARAM_MANAGEMENT = 'RuleParamManagement';
    public static DELETE_RULE_PARAM = 'DeleteRuleParam';
    public static UPDATE_RULE_PARAM = 'UpdateRuleParam';
    public static ADD_RULE_PARAM = 'AddRuleParam';


    public static SUCCESS = 'SUCCESS';
    public static FAILURE = 'FAILURE';

    // Entity Archival events Tracking.
    public static ENTITY_ARCHIVAL = 'EntityArchival';
    public static PERFORM_ENTITY_ARCHIVAL = 'PerformEntityArchival';

    // Task description update events Tracking.
    public static TASK_MANAGEMENT = 'TaskManagement';
    public static TASK_GUIDE_TEXT_UPDATE = 'TaskGuideTextUpdate';
    public static PERFORM_TASK_GUIDE_TEXT_UPDATE = 'PerformTaskGuideTextUpdate';
    public static PERFORM_ADD_TASK = 'PerformAddTask';
    public static PERFORM_UPDATE_TASK = 'PerformUpdateTask';
    public static ACTIVE_WORKFLOW = 'ActiveWorkFlow';
    public static PERFORM_CANCEL_WORKFLOW = 'PerformCancelWorkFlow';

    // Risk Profile Management events Tracking.
    public static RISK_PROFILE_MANAGEMENT = 'RiskProfileMangement';
    public static PERFORM_SUBMIT_RISK_PROFILE = 'PerformSubmitRiskProfile';

    // WTT Client Onboard.
    public static ONBOARD_WTT_CLIENT_UPDATE = 'OnboardWttClient';
    public static PERFORM_ONBOARD_WTT_CLIENT_UPDATE = 'PerformOnboardWttClient';

    // WTT Client Onboard.
    public static ONBOARD_WWFT_CLIENT_UPDATE = 'OnboardWwftClient';
    public static PERFORM_ONBOARD_WWFT_CLIENT_UPDATE = 'PerformOnboardWwftClient';

    // User Managements events Tracking.
    public static USER_MANAGEMENT = 'UserManagement';
    public static SAVE_USER = 'SaveUser';

    // Groups Management
    public static GROUP_MANAGEMENT = 'GroupManagement';
    public static SAVE_GROUP = 'SaveGroup';
    public static GROUP_DELETE = 'DeleteGroup';

    // General Info Card
    public static GENERAL_INFO_TEXT_UPDATE = 'GeneralInfoTextUpdate';
    public static PERFORM_GENERAL_INFO_TEXT_UPDATE = 'PerformGeneralInfoTextUpdate';

    // Address Info Card
    public static ADDRESS_CARD_MANAGEMENT = 'AddressManagement';
    public static ADDRESS_INFO_UPDATE = 'AddressInfoUpdate';
    public static PERFORM_ADDRESS_INFO_UPDATE = 'PerformAddressInfoUpdate';
    public static DELETE_ADDRESS = 'DeleteAddress';

    // General Info Card
    public static MONITORING_ELABORATION_TEXT_UPDATE = 'MonitoringElaborationTextUpdate';
    public static PERFORM_MONITORING_ELABORATION_TEXT_UPDATE = 'PerformMonitoringElaborationTextUpdate';

    // RelationShip info
    public static RELATIONSHIP = 'RELATIONSHIPS';
    public static DELETE_RELATIONSHIP = 'DeleteRelationship';
    public static UBO_RELATIONSHIP = 'UboRelationship';

    // PEP Add
    public static ADD_MANUAL_PEP_MATCH = 'AddManualPepMatch';

    // Transaction Profile Agreements
    public static TRANS_PROFILE_AGREEMENT = 'TransProfileAgreement';
    public static SAVE_AGREEMENT = 'SaveAgreement';
    public static DELETE_AGREEMENT = 'DeleteAgreement';

    // Transaction Profile Documents
    public static TRANS_PROFILE_DOCUMENT = 'TransProfileDocument';
    public static SAVE_DOCUMENT = 'SaveDocument';
    public static DELETE_DOCUMENT = 'DeleteDocument';

    // Transaction Delete
    public static TRANSACTION_DELETE = 'TransactionDelete';
    public static TRANSACTIONS = 'Transactions';
    public static PERFORM_UPDATE_TRANSACTIONS_STATUS = 'UpdateTransactionsStatus';


    // Admin Service Management
    public static ADMIN_SERVICE_MANAGEMENT = 'AdminServiceManagement';
    public static SAVE_ADMIN_SERVICE = 'SaveAdminService';
    public static DELETE_ADMIN_SERVICE = 'DeleteAdminService';
}



// WEBPACK FOOTER //
// ./src/app/shared/services/tracking/tracking-constants.service.ts